import { deliveryConstants } from '../constants'

const initialState = {
  clientPhoto: null,
  dniPhoto: null,
  sign: null,
  oc: null
}

const deliveryReducer = (state = initialState, action) => {

  switch (action.type) {
    case deliveryConstants.CLEAN_ALL:
      return initialState
    case deliveryConstants.SET_OC:
      return {
        ...state,
        oc: action.oc
      }
    case deliveryConstants.SET_CLIENT_PHOTO:
      return {
        ...state,
        clientPhoto: action.image
      }
    case deliveryConstants.SET_DNI_PHOTO:
      return {
        ...state,
        dniPhoto: action.image
      }
    case deliveryConstants.SET_SIGN:
      return {
        ...state,
        sign: action.image
      }
    default:
      return state
  }

}

export default deliveryReducer
